import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getGuestResetpw } from '../../api/orderHistory';
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar';
import { useCommonContext } from '../../components/provider/CommonProvider';
import { PageTitle } from '../../components/title/PageTitle';

export default function GuestOrderPassword() {
  const [guestName, setGuestName] = useState<string>('');
  const [guestOrderNo, setGuestOrderNo] = useState<string>('');
  const [guestPhone, setGuestPhone] = useState<string>('');
  const [phoneCheck, setPhoneCheck] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsLottie } = useCommonContext();

  useEffect(() => {
    setTimeout(() => {
      setIsLottie(false);
    }, 200);
  }, [location]);
  return (
    <div className="main_wrap">
      <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
        <MyShoppingSideBar />
        <div className="findguestpassword">
          <PageTitle>주문 비밀번호 찾기</PageTitle>
          <div className="input_cont wide_w">
            <div className="input_box">
              <p>주문자명</p>
              <input
                type="text"
                placeholder="주문자 이름을 입력해 주세요."
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setGuestName(e.target.value);
                }}
                style={{ color: 'var(--colBlack)' }}
              />
            </div>
            <div className="input_box">
              <p>주문번호</p>
              <input
                type="text"
                placeholder="주문번호를 입력해 주세요."
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setGuestOrderNo(e.target.value);
                }}
                style={{ color: 'var(--colBlack)' }}
              />
            </div>
            <div className="input_box">
              <p>휴대폰 번호</p>
              <input
                type="number"
                placeholder="주문자 휴대폰 번호를 입력해 주세요."
                maxLength={11}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const phoneRegex = /^(01[016789])\d{7,8}$/;
                  if (phoneRegex.test(e.target.value)) {
                    setPhoneCheck(true);
                  } else {
                    setPhoneCheck(false);
                  }

                  setGuestPhone(e.target.value);
                }}
                style={{ color: 'var(--colBlack)' }}
              />
            </div>
          </div>
          {/* <div>
        <button
          type="button"
          onClick={() => {
            getGuestResetpw(guestOrderNo, guestPhone, guestName)
              .then((res) => {
                navigate(`/guestorderlist`);
              })
              .catch((err) => console.log(err));
          }}
        >
          확인
        </button>
      </div> */}
          <div className="button_wrap">
            <Link to="/myshopping" className="cancel_btn">
              취소
            </Link>
            <button
              className="submit_btn"
              onClick={() => {
                if (!guestName) {
                  alert('주문자명을 확인해 주세요');
                  return;
                } else if (!guestOrderNo) {
                  alert('주문번호를 확인해 주세요');
                  return;
                } else if (!guestPhone) {
                  alert('휴대폰 번호를 확인해주세요');
                  return;
                } else if (!phoneCheck) {
                  alert('휴대폰 번호를 확인해주세요');
                  return;
                }
                getGuestResetpw(guestOrderNo, guestPhone, guestName)
                  .then(() => {
                    alert('입력한 번호로 임시 비밀번호를 전송했습니다. 확인해 주세요.');
                    navigate(`/guestorderlist`);
                  })
                  .catch(() => {
                    alert('주문자와 주문번호가 일치하지 않습니다.');
                  });
              }}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
